module.exports = __webpack_public_path__ + "static/011-8e484285ca37b559888707966f67220b.jpg";